const stationsModulePath = '/stations/:stationRecordNumber'

export const routes = {
  home: {
    path: '/',
  },
  loggedOut: {
    path: '/logged-out',
  },
  resources: {
    path: '/resources',
  },
  stationsModule: {
    path: stationsModulePath,
  },
  listSpeci: {
    path: `${stationsModulePath}/speci`,
  },
  newSpeci: {
    path: `${stationsModulePath}/speci/new/:speciId`,
  },
  editSpeci: {
    path: `${stationsModulePath}/speci/edit/:speciId`,
  },
  viewSpeci: {
    path: `${stationsModulePath}/speci/view/:speciId`,
  },
  woolData: {
    path: `${stationsModulePath}/wool-data`,
  },
  woolDataTab: {
    path: `${stationsModulePath}/wool-data/:woolDataTabValue`,
  },
  listOffers: {
    path: `${stationsModulePath}/offers`,
  },
  viewOffer: {
    path: `${stationsModulePath}/offers/view/:offerId`,
  },
}
